import axios from 'axios';
import { useSelector } from 'react-redux';
import React, { useEffect, useState} from "react";
import { useParams } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";
import './setting.css'
import Menu from '../NAVBAR/menu';
import { FiCheck} from "react-icons/fi";
import {url} from '../../URL.js'
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { BiQuestionMark,BiData } from "react-icons/bi";
import Swal from 'sweetalert2' 
import {Toast} from '../../store/action/index.js'
import {useTranslation} from "react-i18next"

export function Setting(){
    const { user} = useAuth0();
    const [usuarioList, setUsuarioList] = useState(null)
    const [users, setUsers] = useState(null)
    const [nombreNew, setNombreNew] = useState('')
    const [pin, setPin] = useState(0)
    const [reload, setReload] = useState(0)
    const [t] = useTranslation("global")

    const [generosDisponibles, setGenerosDisponibles] = useState([])
    const [filosDisponibles, setFilosDisponibles] = useState([])
    const [bulkGenero, setBulkGenero] = useState("")
    const [bulkPosiciones, setBulkPosiciones] = useState([])
    const [bulkPreview, setBulkPreview] = useState(null)
    const [bulkLoading, setBulkLoading] = useState(false)
    const [bulkFiloFilter, setBulkFiloFilter] = useState("")
    const [bulkTableSelection, setBulkTableSelection] = useState({
      especimenes: true,
      bochones: false
    })

    // Bulk Genus/Species Update State
    const [bulkGenOrig, setBulkGenOrig] = useState("")
    const [bulkEspOrig, setBulkEspOrig] = useState("")
    const [bulkGenNew, setBulkGenNew] = useState("")
    const [bulkEspNew, setBulkEspNew] = useState("")
    const [especiesOrigDisponibles, setEspeciesOrigDisponibles] = useState([])
    const [bulkGenEspLoading, setBulkGenEspLoading] = useState(false)
    
    // Advanced Bulk Gen/Esp creation state
    const [allGeneroEspecie, setAllGeneroEspecie] = useState([])
    const [newEspeciesFiltradas, setNewEspeciesFiltradas] = useState([])
    const [errorsBulk, setErrorsBulk] = useState({ genero: false, especie: false })

    // Master Data Management State
    const [masterCat, setMasterCat] = useState('genero')
    const [masterData, setMasterData] = useState([])
    const [masterSearch, setMasterSearch] = useState('')
    const [masterLoading, setMasterLoading] = useState(false)

    useEffect(() => {
       axios.get(`${url}usuariosRoute/usuario`)
       .then(res => {
        setUsuarioList(res.data)
       })
       .catch(() => {})

       if (user?.sub) {
         axios.get(`${url}usuariosRoute/usuario?id=`+ user.sub)
         .then(user => {
          setUsers(user.data)
         })
         .catch(() => {})
       }
      
       axios.get(`${url}tablas/?parametro=genero`)
       .then((res) => {
        setAllGeneroEspecie(res.data || [])
        const list = (res.data || [])
          .map((x) => x?.genero)
          .filter(Boolean);
        setGenerosDisponibles(Array.from(new Set(list)).sort());
       })
       .catch(() => {})

       axios.get(`${url}tablas/?parametro=filo`)
       .then((res) => {
        const list = (res.data || [])
          .map((x) => x?.filo)
          .filter(Boolean);
        setFilosDisponibles(Array.from(new Set(list)).sort());
       })
       .catch(() => {})
      
        }, [reload, user?.sub])

    function selectBulkGenero(g){
      setBulkGenero(g)
      setBulkPosiciones([])
      setBulkPreview(null)
    }

    function toggleBulkPosicion(pos){
      setBulkPosiciones((prev) => {
        const set = new Set(prev || [])
        if(set.has(pos)) set.delete(pos)
        else set.add(pos)
        return Array.from(set)
      })
    }

    async function aplicarBulkPosicionFilo(){
      const posiciones = Array.from(new Set((bulkPosiciones || []).filter(Boolean))).sort();
      if(!bulkGenero || posiciones.length === 0) return;
      if(!bulkTableSelection.especimenes && !bulkTableSelection.bochones) return;

      try{
        setBulkLoading(true)
        
        let totalWillChange = 0;
        let totalRows = 0;
        let previewResults = [];

        // Preview para especímenes si está seleccionado
        if(bulkTableSelection.especimenes){
          const prev = await axios.post(`${url}especimenRoute/posicionfilo/bulk/preview`, {
            genero: bulkGenero,
            posiciones
          })
          previewResults.push({
            tabla: "Especímenes",
            willChange: prev.data?.willChange ?? 0,
            total: prev.data?.total ?? 0
          })
          totalWillChange += (prev.data?.willChange ?? 0);
          totalRows += (prev.data?.total ?? 0);
        }

        // Preview para bochones si está seleccionado
        if(bulkTableSelection.bochones){
          const prev = await axios.post(`${url}bochonRoute/posicionfilo/bulk/preview`, {
            genero: bulkGenero,
            posiciones
          })
          previewResults.push({
            tabla: "Bochones",
            willChange: prev.data?.willChange ?? 0,
            total: prev.data?.total ?? 0
          })
          totalWillChange += (prev.data?.willChange ?? 0);
          totalRows += (prev.data?.total ?? 0);
        }

        let detailText = previewResults.length > 0 
          ? previewResults.map(p => `${p.tabla}: ${p.willChange}/${p.total}`).join("<br/>")
          : "";

        const res = await Swal.fire({
          title: t("BULK_FILO_CONFIRM_TITLE"),
          html: `${t("BULK_FILO_CONFIRM_TEXT")} <b>${bulkGenero}</b>.<br/><br/>${t("BULK_FILO_WILL_CHANGE")} <b>${totalWillChange}</b> / ${totalRows}<br/><br/><small>${detailText}</small>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: t("SI"),
          cancelButtonText: t("CANCEL"),
          confirmButtonColor: "#2f5a4a",
          cancelButtonColor: "#6b705c",
          reverseButtons: true,
        })

        if(!res.isConfirmed){
          setBulkLoading(false)
          return
        }

        let totalUpdated = 0;

        // Aplicar cambios en especímenes si está seleccionado
        if(bulkTableSelection.especimenes){
          const applied = await axios.put(`${url}especimenRoute/posicionfilo/bulk`, {
            genero: bulkGenero,
            posiciones
          })
          totalUpdated += (applied?.data?.updated ?? 0);
        }

        // Aplicar cambios en bochones si está seleccionado
        if(bulkTableSelection.bochones){
          const applied = await axios.put(`${url}bochonRoute/posicionfilo/bulk`, {
            genero: bulkGenero,
            posiciones
          })
          totalUpdated += (applied?.data?.updated ?? 0);
        }

        Toast.fire({
          icon: 'success',
          title: `${t("BULK_FILO_SUCCESS")} (${totalUpdated})`
        })

      } catch(err){
        console.error(err)
        Swal.fire({
          title: "Error",
          text: t("BULK_FILO_ERROR"),
          icon: "error"
        })
      } finally {
        setBulkLoading(false)
      }
    }

    // Logistic for Bulk Genus/Species Update
    function selectBulkGenOrig(g) {
      setBulkGenOrig(g);
      setBulkEspOrig("");
      setEspeciesOrigDisponibles([]);
      if (g) {
        axios.get(`${url}tablas/?parametro=genero`)
          .then((res) => {
            const entry = (res.data || []).find(item => item.genero === g);
            if (entry && Array.isArray(entry.especie)) {
              setEspeciesOrigDisponibles(entry.especie.sort());
            }
          })
          .catch(err => console.error("Error fetching species:", err));
      }
    }

    async function aplicarBulkGeneroEspecie() {
      if (!bulkGenOrig || !bulkEspOrig || !bulkGenNew || !bulkEspNew) return;
      if (!bulkTableSelection.especimenes && !bulkTableSelection.bochones) return;

      try {
        setBulkGenEspLoading(true);
        let totalWillChange = 0;
        let previewResults = [];

        // Preview Especímenes
        if (bulkTableSelection.especimenes) {
          const prev = await axios.post(`${url}especimenRoute/generoespecie/bulk/preview`, {
            generoOrig: bulkGenOrig,
            especieOrig: bulkEspOrig
          });
          previewResults.push({ tabla: "Especímenes", count: prev.data?.total ?? 0 });
          totalWillChange += (prev.data?.total ?? 0);
        }

        // Preview Bochones
        if (bulkTableSelection.bochones) {
          const prev = await axios.post(`${url}bochonRoute/generoespecie/bulk/preview`, {
            generoOrig: bulkGenOrig,
            especieOrig: bulkEspOrig
          });
          previewResults.push({ tabla: "Bochones", count: prev.data?.total ?? 0 });
          totalWillChange += (prev.data?.total ?? 0);
        }

        let detailText = previewResults.map(p => `${p.tabla}: ${p.count}`).join("<br/>");

        const res = await Swal.fire({
          title: t("BULK_GENESP_CONFIRM_TITLE"),
          html: `${t("BULK_GENESP_CONFIRM_TEXT")} <br/><b>${bulkGenOrig} ${bulkEspOrig}</b><br/>${t("BULK_GENESP_CONFIRM_TO")}<br/><b>${bulkGenNew} ${bulkEspNew}</b>.<br/><br/>${t("BULK_FILO_WILL_CHANGE")} <b>${totalWillChange}</b><br/><small>${detailText}</small>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: t("SI"),
          cancelButtonText: t("CANCEL"),
          confirmButtonColor: "#2f5a4a",
          cancelButtonColor: "#6b705c",
          reverseButtons: true,
        });

        if (!res.isConfirmed) {
          setBulkGenEspLoading(false);
          return;
        }

        let totalUpdated = 0;
        if (bulkTableSelection.especimenes) {
          const updated = await axios.put(`${url}especimenRoute/generoespecie/bulk`, {
            generoOrig: bulkGenOrig,
            especieOrig: bulkEspOrig,
            generoNuevo: bulkGenNew,
            especieNuevo: bulkEspNew
          });
          totalUpdated += (updated.data?.updated ?? 0);
        }
        if (bulkTableSelection.bochones) {
          const updated = await axios.put(`${url}bochonRoute/generoespecie/bulk`, {
            generoOrig: bulkGenOrig,
            especieOrig: bulkEspOrig,
            generoNuevo: bulkGenNew,
            especieNuevo: bulkEspNew
          });
          totalUpdated += (updated.data?.updated ?? 0);
        }

        Toast.fire({
          icon: 'success',
          title: `${t("BULK_GENESP_SUCCESS")} (${totalUpdated})`
        });

        setBulkGenOrig("");
        setBulkEspOrig("");
        setBulkGenNew("");
        setBulkEspNew("");

      } catch (err) {
        console.error(err);
        Swal.fire({
          title: "Error",
          text: t("BULK_GENESP_ERROR"),
          icon: "error"
        });
      } finally {
        setBulkGenEspLoading(false);
      }
    }

    function handleNewGenChange(e) {
      const val = e.target.value;
      setBulkGenNew(val);
      
      const exists = allGeneroEspecie.find(g => g.genero === val);
      if (!exists && val.length > 0) {
        setErrorsBulk(prev => ({ ...prev, genero: true }));
        setNewEspeciesFiltradas([]);
      } else {
        setErrorsBulk(prev => ({ ...prev, genero: false }));
        if (exists && Array.isArray(exists.especie)) {
          setNewEspeciesFiltradas(exists.especie.sort());
        } else {
          setNewEspeciesFiltradas([]);
        }
      }
    }

    function handleNewEspChange(e) {
      const val = e.target.value;
      setBulkEspNew(val);
      
      if (val.length === 0) {
        setErrorsBulk(prev => ({ ...prev, especie: false }));
        return;
      }

      const exists = newEspeciesFiltradas.includes(val);
      if (!exists) {
        setErrorsBulk(prev => ({ ...prev, especie: true }));
      } else {
        setErrorsBulk(prev => ({ ...prev, especie: false }));
      }
    }

    async function crearGeneroBulk(e) {
      e.preventDefault();
      if (!bulkGenNew) return;
      try {
        setBulkGenEspLoading(true);
        await axios.post(`${url}tablas?modelo=genero&primario=${bulkGenNew}`);
        setErrorsBulk(prev => ({ ...prev, genero: false }));
        Toast.fire({ icon: 'success', title: t("EXITO") });
        // Refresh listing
        const res = await axios.get(`${url}tablas/?parametro=genero`);
        const data = res.data || [];
        setAllGeneroEspecie(data);
        const list = data.map(x => x?.genero).filter(Boolean);
        setGenerosDisponibles(Array.from(new Set(list)).sort());
        
        const exists = data.find(g => g.genero === bulkGenNew);
        if (exists && Array.isArray(exists.especie)) {
          setNewEspeciesFiltradas(exists.especie.sort());
        }
      } catch (err) {
        console.error(err);
      } finally {
        setBulkGenEspLoading(false);
      }
    }

    async function crearEspecieBulk(e) {
      e.preventDefault();
      if (!bulkGenNew || !bulkEspNew) return;
      try {
        setBulkGenEspLoading(true);
        await axios.post(`${url}tablas?modelo=genero&primario=${bulkGenNew}&secundario=${bulkEspNew}`);
        setErrorsBulk(prev => ({ ...prev, especie: false }));
        Toast.fire({ icon: 'success', title: t("EXITO") });
        // Refresh listing
        const res = await axios.get(`${url}tablas/?parametro=genero`);
        const data = res.data || [];
        setAllGeneroEspecie(data);
        const exists = data.find(g => g.genero === bulkGenNew);
        if (exists && Array.isArray(exists.especie)) {
          setNewEspeciesFiltradas(exists.especie.sort());
        }
      } catch (err) {
        console.error(err);
      } finally {
        setBulkGenEspLoading(false);
      }
    }

    function modificarNivel(e, elemento){
        let newLevel = e.target.value
        let idUser = elemento.id
        let obj = {
            id: idUser,
            nivel: newLevel
        }
        axios.put(`${url}usuariosRoute/modificarUsuario`, obj)
        .then(()=> Toast.fire({
            icon: 'success',
            title: 'Nivel de Usuario modificado'
          }) )
          setReload(reload +1 )
        axios.get(`${url}usuariosRoute/usuario`)
        .then(res => {
         setUsuarioList(res.data)
        })

    }

    // Master Data Management Logic
    const fetchMasterData = async (cat) => {
      try {
        setMasterLoading(true);
        let param = '';
        if (cat === 'genero') param = 'genero';
        else if (cat === 'filo') param = 'filo';
        else if (cat === 'cuenca') param = 'formacion';
        else if (cat === 'partes') param = 'partes';

        const res = await axios.get(`${url}tablas/?parametro=${param}`);
        setMasterData(res.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setMasterLoading(false);
      }
    };

    useEffect(() => {
      if (users?.nivel === 1) {
        fetchMasterData(masterCat);
      }
    }, [masterCat, users?.nivel]);

    const handleMasterEdit = async (valorAnterior, padre = null, categoria = masterCat) => {
      let label = t("MASTER_DATA_NEW_VALUE");
      const { value: valorNuevo } = await Swal.fire({
        title: t("MASTER_DATA_EDIT_TITLE"),
        input: 'text',
        inputValue: valorAnterior,
        inputLabel: label,
        showCancelButton: true,
        confirmButtonColor: "#2f5a4a",
        cancelButtonColor: "#6b705c",
      });

      if (!valorNuevo || valorNuevo === valorAnterior) return;

      try {
        setMasterLoading(true);
        let countRes = { data: { total: 0 } };
        let realCat = categoria; 
        // Logic to determine if it's a child or parent
        if (categoria === 'genero' && padre) realCat = 'especie';
        if (categoria === 'cuenca' && padre) realCat = 'formacion';
        if (categoria === 'partes' && padre) realCat = 'parteSecundaria';
        if (categoria === 'partes' && !padre) realCat = 'parte';

        // Get count of associated items
        countRes = await axios.get(`${url}tablas/count`, {
          params: { categoria: realCat, valor: padre || valorAnterior, secundario: padre ? valorAnterior : null }
        });

        const count = countRes.data.total;
        let cascade = false;

        if (count > 0 && (realCat === 'genero' || realCat === 'especie')) {
          const res = await Swal.fire({
            title: t("MASTER_DATA_CASCADE_ASK"),
            text: t("MASTER_DATA_CASCADE_WARN", { count }),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t("MASTER_DATA_CASCADE_YES"),
            cancelButtonText: t("MASTER_DATA_CASCADE_NO"),
            confirmButtonColor: "#2f5a4a",
            cancelButtonColor: "#6b705c",
          });
          if (res.isConfirmed) cascade = true;
          else if (res.dismiss === Swal.DismissReason.cancel) cascade = false;
          else { setMasterLoading(false); return; }
        }

        await axios.put(`${url}tablas/update`, {
          categoria: realCat,
          valorAnterior,
          valorNuevo,
          padre,
          cascade
        });

        Toast.fire({ icon: 'success', title: t("MASTER_DATA_SUCCESS_UPDATE") });
        fetchMasterData(masterCat);
        setReload(r => r + 1);
      } catch (err) {
        console.error(err);
        Swal.fire('Error', t("SOMETHING_WRONG"), 'error');
      } finally {
        setMasterLoading(false);
      }
    };

    const handleMasterDelete = async (valor, padre = null, categoria = masterCat) => {
      try {
        let realCat = categoria;
        if (categoria === 'genero' && padre) realCat = 'especie';
        if (categoria === 'cuenca' && padre) realCat = 'formacion';
        if (categoria === 'partes' && padre) realCat = 'parteSecundaria';
        if (categoria === 'partes' && !padre) realCat = 'parte';

        const countRes = await axios.get(`${url}tablas/count`, {
          params: { categoria: realCat, valor: padre || valor, secundario: padre ? valor : null }
        });

        const count = countRes.data.total;

        if (count > 0 && (realCat === 'genero' || realCat === 'especie')) {
           await Swal.fire({
            title: t("MASTER_DATA_CASCADE_WARN", { count }),
            text: "No puedes eliminar este registro porque tiene elementos asociados. Por favor, cámbialos de género/especie primero.",
            icon: 'error',
            confirmButtonColor: "#2f5a4a",
          });
          return;
        }

        const res = await Swal.fire({
          title: t("MASTER_DATA_DELETE_CONFIRM"),
          text: t("MASTER_DATA_DELETE_TEXT"),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#6b705c",
          confirmButtonText: t("ELI"),
          cancelButtonText: t("CAN")
        });

        if (!res.isConfirmed) return;

        setMasterLoading(true);
        await axios.delete(`${url}tablas/delete`, {
          params: { categoria: realCat, valor, padre }
        });

        Toast.fire({ icon: 'success', title: t("MASTER_DATA_SUCCESS_DELETE") });
        fetchMasterData(masterCat);
        setReload(r => r + 1);
      } catch (err) {
        console.error(err);
        Swal.fire('Error', t("SOMETHING_WRONG"), 'error');
      } finally {
        setMasterLoading(false);
      }
    };
   
    function cambiarNombre(e){
        if(e.target.value){
            setNombreNew({nombre:e.target.value, id: user.sub})
        }
        else{
            setNombreNew('')
        }
    }
    function submitNombre(e){
        e.preventDefault()
        axios.put(`${url}usuariosRoute/modificarUsuario`, nombreNew).then(()=>Toast.fire({
            icon: 'success',
            title: 'Cambio de Nombre exitoso'
          }))
        document.getElementById('nombre').value = nombreNew.nombre
        setNombreNew('')
    }
   
    const styleImg = {
        width: '46px',
        borderRadius: '50px'
    }
    function SortArray(x, y){
        if (x.nivel < y.nivel) {return -1;}
        if (x.nivel > y.nivel) {return 1;}
        return 0;
    }
    const popover = (
        <Popover id="popover-basic">
          <Popover.Header as="h3">{t("DIF")}</Popover.Header>
          <Popover.Body>
                   <strong>Nivel-1 : </strong>{t("TOTAL")}<br/>
                   <strong>Nivel-2 : </strong>{t("CREA")} <br/>
                   <strong>Nivel-3 : </strong>{t("SOLO")} <br/>
                   <strong>Nivel-4 : </strong>{t("MINI")}<br/>
          </Popover.Body>
        </Popover>
      );
    
    let usuariosListFinalySort = usuarioList?.sort(SortArray)
    function activePIN(){
        setPin(1)
    }
    function cambiarPIN(e){
        e.preventDefault()
       var pinActual = users?.contrasena;
       var pinViejo = document.getElementById('pinViejo').value
       var pinNuevo = document.getElementById('pinNuevo').value
   
        if(pinActual === pinViejo && pinNuevo.length === 4){
            Swal.fire({
                title: t("CONFI"),
                toast: true,
                showDenyButton: true,
                confirmButtonText:  t("SI"),
                denyButtonText: t("CAN"),
              }).then((result) => {
                if (result.isConfirmed) {
                    var cambio = {id: user.sub, contrasena: pinNuevo }
                    axios.put(`${url}usuariosRoute/modificarUsuario`, cambio).then(()=>
                          Toast.fire({
                            icon: 'success',
                            title:  t("+CONFI")
                          })
                    )
                    setPin(0)
                } 
              })
        } else if (pinActual !== pinViejo) {
            Toast.fire({
                icon: 'error',
                title:  t("NOPIN")
              })
            document.getElementById('pinViejo').value = '';
            document.getElementById('pinNuevo').value = '';
        } else {
            Toast.fire({
                icon: 'alert',
                title:  t("AGAIN")
              })
        }
    }

    return (
        <div className='settingsDashboard'>
            <Menu activo={5} />

            <div className="settingsMainContent">
                <header className="settingsHeader">
                    <h1 className="settingsTitle">{t("AJUSER")}</h1>
                    {users?.nivel === 1 && (
                        <div className="adminActions">
                            <span tooltip={t("DES")} flow='left'>
                                <a className='backupButton' href={`${url}backup/`} download='back' target='_blank' rel="noreferrer">
                                    <BiData /> <span>Backup</span>
                                </a>
                            </span>
                        </div>
                    )}
                </header>

                <div className="settingsGrid">
                    {/* --- PROFILE SECTION --- */}
                    <section className="settingsSection profileSection">
                        <div className='settingsCard'>
                            <h2 className='cardTitle'>{t("CAM")}</h2>
                            <div className='cardBody'>
                                <div className='inputGroup'>
                                    <input
                                        type='text'
                                        name='nombre'
                                        id='nombre'
                                        className='modernInput'
                                        placeholder={users?.nombre}
                                        onChange={(e) => cambiarNombre(e)}
                                    />
                                    {nombreNew.nombre && (
                                        <button className='confirmBtn' onClick={(e) => submitNombre(e)}>
                                            <FiCheck />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className='settingsCard pinCard'>
                            <h2 className='cardTitle'>{t("-PIN")}</h2>
                            <div className='cardBody'>
                                {pin === 1 ? (
                                    <form className='modernForm' onSubmit={(e) => cambiarPIN(e)}>
                                        <div className='formField'>
                                            <label>{t("PIN")}:</label>
                                            <input type='password' id='pinViejo' className="modernInput smallInput" maxLength='4' pattern="[0-9]*" required inputMode="numeric" />
                                        </div>
                                        <div className='formField'>
                                            <label>{t("+PIN")}:</label>
                                            <input type='password' id='pinNuevo' className="modernInput smallInput" autoComplete='off' maxLength='4' required pattern="[0-9]*" inputMode="numeric" />
                                        </div>
                                        <button className='confirmBtn' type='submit'><FiCheck /></button>
                                    </form>
                                ) : (
                                    <button className='actionBtn outline' onClick={(e) => activePIN()}>{t("-PIN")}</button>
                                )}
                            </div>
                        </div>
                    </section>

                    {/* --- ADMIN SECTION --- */}
                    {users?.nivel === 1 && (
                        <section className="settingsSection adminSection">
                            <div className='settingsCard usersTableCard'>
                                <div className='cardHeader'>
                                    <h2 className='cardTitle'>{t("LEVEL")}</h2>
                                    <div className='headerActions'>
                                        <p className="levelLabel">{t("NIVEL")}</p>
                                        <OverlayTrigger trigger="click" placement="right" overlay={popover}>
                                            <Button size='sm' variant='ghost' className='helpBtn'><BiQuestionMark size="20px" /></Button>
                                        </OverlayTrigger>
                                    </div>
                                </div>

                                <div className='tableWrapper'>
                                    <table className="modernTable">
                                        <thead>
                                            <tr>
                                                <th>{t("NAME")}</th>
                                                <th>{t("MAIL")}</th>
                                                <th>{t("LEVEL")}</th>
                                                <th>{t("+LEVEL")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {usuariosListFinalySort?.map((elemento) => (
                                                <tr key={elemento.id}>
                                                    <td className="userCell">
                                                        <img src={elemento.imagen} style={styleImg} alt="" />
                                                        <span>{elemento.nombre}</span>
                                                    </td>
                                                    <td>{elemento.correo}</td>
                                                    <td>
                                                        <span className={`levelBadge level-${elemento.nivel}`}>
                                                            {elemento.nivel}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <select className="modernSelect mini" onChange={(e) => modificarNivel(e, elemento)}>
                                                            <option>{t("+LEVEL").toLocaleLowerCase()}</option>
                                                            <option value='1'>1</option>
                                                            <option value='2'>2</option>
                                                            <option value='3'>3</option>
                                                            <option value='4'>4</option>
                                                        </select>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className='bulkToolsHeader'>
                                <h3 className='sectionSubtitle'>Herramientas de Actualización Masiva</h3>
                                <div className='bulkTableSelectionCard'>
                                    <span className='selectionLabel'>Tablas a afectar:</span>
                                    <div className='selectionToggles'>
                                        <label className='modernToggle'>
                                            <input
                                                type="checkbox"
                                                checked={bulkTableSelection.especimenes}
                                                onChange={(e) => setBulkTableSelection({
                                                    ...bulkTableSelection,
                                                    especimenes: e.target.checked
                                                })}
                                            />
                                            <span className="toggleSlider"></span>
                                            <span className="toggleLabel">Especímenes</span>
                                        </label>
                                        <label className='modernToggle'>
                                            <input
                                                type="checkbox"
                                                checked={bulkTableSelection.bochones}
                                                onChange={(e) => setBulkTableSelection({
                                                    ...bulkTableSelection,
                                                    bochones: e.target.checked
                                                })}
                                            />
                                            <span className="toggleSlider"></span>
                                            <span className="toggleLabel">Bochones</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className='bulkPanelsContainer'>
                                <div className='settingsCard bulkPanelCard'>
                                    <div className='cardHeader'>
                                        <h2 className='cardTitle'>{t("BULK_FILO_TITLE")}</h2>
                                        <p className='cardSubtitle'>{t("BULK_FILO_SUBTITLE")}</p>
                                    </div>

                                    <div className='cardBody'>
                                        <div className='formGroup'>
                                            <label className='formLabel'>{t("BULK_FILO_GENRE")}</label>
                                            <select
                                                className='modernSelect'
                                                value={bulkGenero}
                                                onChange={(e) => selectBulkGenero(e.target.value)}
                                            >
                                                <option value="">{t("BULK_FILO_FILTER_GENRE")}</option>
                                                {(generosDisponibles || []).map((g) => (
                                                    <option key={g} value={g}>{g}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className='formGroup'>
                                            <label className='formLabel'>{t("BULK_FILO_POS")}</label>
                                            <input
                                                className='modernInput'
                                                type='text'
                                                value={bulkFiloFilter}
                                                onChange={(e) => setBulkFiloFilter(e.target.value)}
                                                placeholder={t("BULK_FILO_FILTER_POS")}
                                                disabled={!bulkGenero}
                                            />

                                            <div className='chipsContainer'>
                                                {bulkPosiciones?.slice().sort().map((p) => (
                                                    <button
                                                        type="button"
                                                        key={p}
                                                        className='modernChip'
                                                        onClick={() => toggleBulkPosicion(p)}
                                                        disabled={bulkLoading}
                                                    >
                                                        {p} <span className="chipDelete">×</span>
                                                    </button>
                                                ))}
                                            </div>

                                            <div className='checklistContainer'>
                                                {(filosDisponibles || [])
                                                    .filter((p) => !bulkFiloFilter || String(p).toLowerCase().includes(bulkFiloFilter.toLowerCase()))
                                                    .slice(0, 500)
                                                    .map((p) => (
                                                        <label key={p} className='checkItem'>
                                                            <input
                                                                type="checkbox"
                                                                checked={(bulkPosiciones || []).includes(p)}
                                                                disabled={!bulkGenero || bulkLoading}
                                                                onChange={() => toggleBulkPosicion(p)}
                                                            />
                                                            <span>{p}</span>
                                                        </label>
                                                    ))}
                                            </div>
                                        </div>

                                        <div className='cardActions'>
                                            <button
                                                type="button"
                                                className='modernActionBtn primary'
                                                disabled={!bulkGenero || (bulkPosiciones?.length ?? 0) === 0 || bulkLoading}
                                                onClick={() => aplicarBulkPosicionFilo()}
                                            >
                                                {bulkLoading ? t("BULK_FILO_WORKING") : t("BULK_FILO_APPLY")}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className='settingsCard bulkPanelCard'>
                                    <div className='cardHeader'>
                                        <h2 className='cardTitle'>{t("BULK_GENESP_TITLE")}</h2>
                                        <p className='cardSubtitle'>{t("BULK_GENESP_SUBTITLE")}</p>
                                    </div>

                                    <div className='cardBody'>
                                        <div className='bulkGenEspGrid'>
                                            <div className='formGroup'>
                                                <label className='formLabel'>{t("BULK_GENESP_ORIG_GENRE")}</label>
                                                <select
                                                    className='modernSelect'
                                                    value={bulkGenOrig}
                                                    onChange={(e) => selectBulkGenOrig(e.target.value)}
                                                    disabled={bulkGenEspLoading}
                                                >
                                                    <option value="">{t("BULK_FILO_FILTER_GENRE")}</option>
                                                    {(generosDisponibles || []).map((g) => (
                                                        <option key={g} value={g}>{g}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className='formGroup'>
                                                <label className='formLabel'>{t("BULK_GENESP_ORIG_SPECIES")}</label>
                                                <select
                                                    className='modernSelect'
                                                    value={bulkEspOrig}
                                                    onChange={(e) => setBulkEspOrig(e.target.value)}
                                                    disabled={!bulkGenOrig || bulkGenEspLoading}
                                                >
                                                    <option value="">{t("BULK_GENESP_FILTER_SPECIES")}</option>
                                                    {(especiesOrigDisponibles || []).map((s) => (
                                                        <option key={s} value={s}>{s}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className='formGroup'>
                                                <label className='formLabel'>{t("BULK_GENESP_NEW_GENRE")}</label>
                                                <div className='relativeInput'>
                                                    <input
                                                        type="text"
                                                        className='modernInput'
                                                        value={bulkGenNew}
                                                        autoComplete="off"
                                                        list="bulkGenerosList"
                                                        onChange={(e) => handleNewGenChange(e)}
                                                        placeholder={t("BULK_GENESP_NEW_GENRE")}
                                                        disabled={bulkGenEspLoading}
                                                    />
                                                    {errorsBulk.genero && (
                                                        <p className="inlineCreationPrompt" onClick={(e) => crearGeneroBulk(e)}>+ {t("EXITO")}</p>
                                                    )}
                                                </div>
                                            </div>

                                            <div className='formGroup'>
                                                <label className='formLabel'>{t("BULK_GENESP_NEW_SPECIES")}</label>
                                                <div className='relativeInput'>
                                                    <input
                                                        type="text"
                                                        className='modernInput'
                                                        value={bulkEspNew}
                                                        autoComplete="off"
                                                        list="bulkEspeciesList"
                                                        onChange={(e) => handleNewEspChange(e)}
                                                        placeholder={t("BULK_GENESP_NEW_SPECIES")}
                                                        disabled={!bulkGenNew || bulkGenEspLoading}
                                                    />
                                                    {errorsBulk.especie && (
                                                        <p className="inlineCreationPrompt" onClick={(e) => crearEspecieBulk(e)}>+ {t("EXITO")}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='cardActions'>
                                            <button
                                                type="button"
                                                className='modernActionBtn primary'
                                                disabled={!bulkGenOrig || !bulkEspOrig || !bulkGenNew || !bulkEspNew || bulkGenEspLoading || errorsBulk.genero || errorsBulk.especie}
                                                onClick={() => aplicarBulkGeneroEspecie()}
                                            >
                                                {bulkGenEspLoading ? t("BULK_FILO_WORKING") : t("BULK_FILO_APPLY")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}

                    {/* --- MASTER DATA MANAGEMENT --- */}
                    {users?.nivel === 1 && (
                        <section className="settingsSection masterDataSection">
                            <div className='settingsCard masterDataCard'>
                                <div className='cardHeader'>
                                    <h2 className='cardTitle'>{t("MASTER_DATA_TITLE")}</h2>
                                    <p className='cardSubtitle'>{t("MASTER_DATA_SUBTITLE")}</p>
                                </div>

                                <div className='cardBody'>
                                    <div className='masterDataControls'>
                                        <div className='formGroup'>
                                            <label className='formLabel'>{t("MASTER_DATA_SELECT_CAT")}</label>
                                            <div className='categoryTabs'>
                                                <button 
                                                    className={`tabBtn ${masterCat === 'genero' ? 'active' : ''}`}
                                                    onClick={() => setMasterCat('genero')}
                                                >
                                                    {t("MASTER_DATA_GENESP")}
                                                </button>
                                                <button 
                                                    className={`tabBtn ${masterCat === 'filo' ? 'active' : ''}`}
                                                    onClick={() => setMasterCat('filo')}
                                                >
                                                    {t("MASTER_DATA_PHYLO")}
                                                </button>
                                                <button 
                                                    className={`tabBtn ${masterCat === 'cuenca' ? 'active' : ''}`}
                                                    onClick={() => setMasterCat('cuenca')}
                                                >
                                                    {t("MASTER_DATA_CUENCAFORMA")}
                                                </button>
                                                <button 
                                                    className={`tabBtn ${masterCat === 'partes' ? 'active' : ''}`}
                                                    onClick={() => setMasterCat('partes')}
                                                >
                                                    {t("MASTER_DATA_PARTES")}
                                                </button>
                                            </div>
                                        </div>

                                        <div className='formGroup'>
                                            <input 
                                                type='text'
                                                className='modernInput'
                                                placeholder={t("MASTER_DATA_SEARCH_PLACEHOLDER")}
                                                value={masterSearch}
                                                onChange={(e) => setMasterSearch(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className={`masterDataList ${masterLoading ? 'loading' : ''}`}>
                                        {masterLoading ? (
                                            <div className='loadingSpinner'>{t("LOADING")}</div>
                                        ) : (
                                            <div className='masterItemsContainer'>
                                                {masterData
                                                    .filter(item => {
                                                        const search = masterSearch.toLowerCase();
                                                        if (masterCat === 'genero') return item.genero?.toLowerCase().includes(search) || item.especie?.some(s => s.toLowerCase().includes(search));
                                                        if (masterCat === 'filo') return item.filo?.toLowerCase().includes(search);
                                                        if (masterCat === 'cuenca') return item.cuenca?.toLowerCase().includes(search) || item.formacion?.some(f => f.toLowerCase().includes(search));
                                                        if (masterCat === 'partes') return item.principal?.toLowerCase().includes(search) || item.secundaria?.some(s => s.toLowerCase().includes(search));
                                                        return true;
                                                    })
                                                    .map((item, idx) => (
                                                        <div key={idx} className='masterItemRow'>
                                                            <div className='itemMain'>
                                                                <div className='itemContent'>
                                                                    <span className='itemName'>
                                                                        {masterCat === 'genero' ? item.genero : 
                                                                         masterCat === 'filo' ? item.filo :
                                                                         masterCat === 'cuenca' ? item.cuenca :
                                                                         item.principal}
                                                                    </span>
                                                                    <div className='itemActions'>
                                                                        <button className='iconBtn edit' onClick={() => handleMasterEdit(
                                                                            masterCat === 'genero' ? item.genero : 
                                                                            masterCat === 'filo' ? item.filo :
                                                                            masterCat === 'cuenca' ? item.cuenca :
                                                                            item.principal
                                                                        )}>✎</button>
                                                                        <button className='iconBtn delete' onClick={() => handleMasterDelete(
                                                                            masterCat === 'genero' ? item.genero : 
                                                                            masterCat === 'filo' ? item.filo :
                                                                            masterCat === 'cuenca' ? item.cuenca :
                                                                            item.principal
                                                                        )}>🗑</button>
                                                                    </div>
                                                                </div>
                                                                
                                                                {/* Secondary items (species, formations, etc) */}
                                                                {(masterCat === 'genero' || masterCat === 'cuenca' || masterCat === 'partes') && (
                                                                    <div className='subItemsList'>
                                                                        {(masterCat === 'genero' ? item.especie : 
                                                                          masterCat === 'cuenca' ? item.formacion : 
                                                                          item.secundaria)?.map((sub, sidx) => (
                                                                            <div key={sidx} className='subItemTag'>
                                                                                <span>{sub}</span>
                                                                                <div className='subActions'>
                                                                                    <button onClick={() => handleMasterEdit(sub, 
                                                                                        masterCat === 'genero' ? item.genero : 
                                                                                        masterCat === 'cuenca' ? item.cuenca : 
                                                                                        item.principal
                                                                                    )}>✎</button>
                                                                                    <button onClick={() => handleMasterDelete(sub, 
                                                                                        masterCat === 'genero' ? item.genero : 
                                                                                        masterCat === 'cuenca' ? item.cuenca : 
                                                                                        item.principal
                                                                                    )}>×</button>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                                {masterData.length === 0 && !masterLoading && (
                                                    <p className='emptyMsg'>{t("MASTER_DATA_EMPTY")}</p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}
                </div>

                <datalist id='bulkGenerosList'>
                    {generosDisponibles.map(g => <option key={g} value={g} />)}
                </datalist>
                <datalist id='bulkEspeciesList'>
                    {newEspeciesFiltradas.map(s => <option key={s} value={s} />)}
                </datalist>
            </div>
        </div>
    );
}
